import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_app_footer = _resolveComponent("app-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_header, {
      ref: "AppHeader",
      isAuthenticated: _ctx.IsAuthenticated
    }, null, 8, ["isAuthenticated"]),
    _createVNode(_component_router_view),
    _createVNode(_component_app_footer, { ref: "AppFooter" }, null, 512)
  ], 64))
}